<template>
    <html>
      <body class="" style="background: #FFF">
        <Header />
          <MenuLateralMobile />
          <div class="h-screen grid grid-cols-6 grid-rows-12 grid-flow-col">
             <MenuLateral/>
              <div class="col-span-6" style="background:#FFF;padding:20px;">
                <CustomerFolioConfiguration />
                <Footer/>
              </div>
          </div>
      </body>
    </html>
  </template>
  
  <script>

  import CustomerFolioConfiguration from "@/components/Administrative/Reports/CustomerFolioConfiguration.vue";
  import Header from "@/components/Administrative/Header/Header.vue";
  import MenuLateralMobile from '@/components/MenuLateralMobile.vue';
  import MenuLateral from '@/components/LateralMenu.vue';
  import Footer from '@/components/Analyst/Footer.vue';

  export default {

    components: {
      Header,
      CustomerFolioConfiguration,
      MenuLateral,
      MenuLateralMobile,
      Footer
    }
  }
  </script>
  
  <style scoped>
  
  </style>